function hasOwnProperty(object: Record<string, never>, key: string): boolean {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function isEmptyObject(param: Record<string, never>): boolean {
  return isObject(param) && !Object.keys(param).length;
}

function isObject(param: unknown): param is Record<string, never> {
  return param != null && typeof param === 'object';
}

export function diff(obj1: unknown, obj2: unknown): unknown {
  if (obj1 === obj2) return {};

  if (!isObject(obj1) || !isObject(obj2)) {
    return obj2;
  }

  const deletedValues = Object.keys(obj1).reduce(
    (acc, key) => ({
      ...acc,
      ...(!hasOwnProperty(obj2, key) && {
        [key]: undefined,
      }),
    }),
    {},
  );

  return Object.keys(obj2).reduce((acc, key) => {
    if (!hasOwnProperty(obj1, key)) {
      acc[key] = obj2[key];
      return acc;
    }

    const difference = diff(obj1[key], obj2[key]) as Record<string, never>;

    if (
      isEmptyObject(difference) &&
      (isEmptyObject(obj1[key]) || !isEmptyObject(obj2[key]))
    )
      return acc;

    acc[key] = difference;

    return acc;
  }, deletedValues);
}
